import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container max-w-4xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-center text-gray-900 mb-12">Privacy Policy</h1>
        
        <div className="bg-white rounded-xl shadow-lg p-8 space-y-6">
        <section>
        <h2 className="text-2xl font-semibold mb-4">1. Information We Collect</h2>
        <p className="text-gray-600">
          We collect information that you provide directly to us when you create an account, use our services, or communicate with us. This includes:
        </p>
        <ul className="list-disc ml-6 text-gray-600">
          <li>Personal information such as your name, email address, phone number, and billing details.</li>
          <li>Content you upload or share through our platform, including comments, messages, or files.</li>
          <li>Information from third-party accounts if you choose to link them with our services.</li>
        </ul>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-4">2. How We Use Your Information</h2>
        <p className="text-gray-600">
          We use the information we collect to:
        </p>
        <ul className="list-disc ml-6 text-gray-600">
          <li>Provide, operate, and maintain our services.</li>
          <li>Personalize your experience and deliver content tailored to your interests.</li>
          <li>Communicate with you about updates, promotions, and customer support inquiries.</li>
          <li>Analyze usage patterns to improve the functionality and performance of our platform.</li>
          <li>Ensure compliance with legal and regulatory requirements.</li>
        </ul>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-4">3. Sharing Your Information</h2>
        <p className="text-gray-600">
          We do not share your personal information with third parties except in the following cases:
        </p>
        <ul className="list-disc ml-6 text-gray-600">
          <li>With service providers who assist us in delivering our services.</li>
          <li>When required by law or to respond to legal processes.</li>
          <li>To protect the rights, property, or safety of our company, users, or others.</li>
          <li>In connection with a merger, sale, or transfer of assets.</li>
        </ul>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-4">4. Your Choices and Rights</h2>
        <p className="text-gray-600">
          You have the following rights regarding your personal information:
        </p>
        <ul className="list-disc ml-6 text-gray-600">
          <li>Access and update your account information through your profile settings.</li>
          <li>Opt out of receiving promotional emails by following the unsubscribe instructions.</li>
          <li>Request the deletion of your personal data, subject to legal obligations.</li>
          <li>Restrict or object to certain data processing activities.</li>
        </ul>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-4">5. Data Security</h2>
        <p className="text-gray-600">
          We implement appropriate technical and organizational measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet or electronic storage is completely secure, so we cannot guarantee absolute security.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-4">6. Changes to This Privacy Policy</h2>
        <p className="text-gray-600">
          We may update this privacy policy from time to time. Any changes will be reflected on this page, and significant updates will be communicated to you directly. We encourage you to review this policy periodically to stay informed about how we protect your information.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-4">7. Contact Us</h2>
        <p className="text-gray-600">
          If you have any questions or concerns about this privacy policy, please contact us at:
        </p>
        <p className="text-gray-600">Email: aihairstylestudio@gmail.com</p>
      </section>

        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;